import React from "react";
import { Spinner } from "reactstrap";

function LoadingGeneral() {
  return (
    <div
      style={{
        justifyContent: "center",
        alignContent: "center",
        display: "flex",
      }}
    >
      <Spinner
        color="primary"
        type="grow"
        size="sm"
        style={{ marginRight: "5px" }}
      />
      <Spinner
        color="danger"
        type="grow"
        size="sm"
        style={{ marginRight: "5px" }}
      />
      <Spinner
        color="success"
        type="grow"
        size="sm"
        style={{ marginRight: "5px" }}
      />
    </div>
  );
}

export default LoadingGeneral;
